export const PRODUCT_TABS = ['Summary'];
